<div class="dictionary-container">
  <div class="left-sidebar">
    <div class="tab-list">
      <div matTooltip="{{ group.title }}"
           *ngFor="let group of itemGroups"
           class="tab-item"
           [class.active]="selectedKey === group.title"
           (click)="selectTab(group.title)">
        {{ group.title }}
      </div>
    </div>
  </div>

  <div class="right-content">
    <div class="content-area" *ngIf="selectedKey">
      <a class="add-button" (click)="addOption()"><i class="fa-regular fa-plus"></i> Add Item</a>

      <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
        <mat-label>{{ selectedKey }}</mat-label>
        <input matInput placeholder="Input" style="display: none">

        <ul>
          <li *ngFor="let item of currentItems; let i = index" #optionItem
              class="flex flex-row justify-between items-center">

            <div class="container flex flex-row justify-start items-center full-grow-no-shrink-no-basis"
                 *ngIf="!editingStates[i]">
              <div class="icons flex flex-col">
                <i class="fa-solid fa-caret-up" (click)="moveOption(i, 'up')"></i>
                <i class="fa-solid fa-caret-down" (click)="moveOption(i, 'down')"></i>
              </div>
              <input type="checkbox" [(ngModel)]="item.isChecked" (change)="onOptionChecked(item)" class="mr-2"/>
              <label class="full-grow-no-shrink-no-basis" title="{{item.text}}"
                     (click)="startEditItem(i)">{{item.text}}</label>
              <div class="right-sidebar-icons">
                <span [matTooltip]="!item.isCustom ? 'You can\'t delete default dynamic item' : ''">
                  <button mat-icon-button class="icon-dropdown-button" [disabled]="!item.isCustom"
                          (click)="removeOption(i)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </span>
              </div>
            </div>

            <div *ngIf="editingStates[i]" class="flex flex-row justify-start items-center">
              <particle-inplace-input
                [text]="item.text"
                placeHolder="Title"
                saveButtonCaption="Done"
                (valueChanged)="onSaveOption($event)"
                (cancelled)='resetEditing()'
              ></particle-inplace-input>
            </div>
          </li>

          <li *ngIf="isOptionEditing" #newItemInput class="flex flex-row justify-between items-center">
            <particle-inplace-input
              [text]="exitingText"
              placeHolder="Title"
              saveButtonCaption="Done"
              (valueChanged)="onSaveOption($event)"
              (cancelled)='resetEditing()'
            ></particle-inplace-input>
          </li>
        </ul>
      </mat-form-field>

      <div class="m-t-10 flex flex-row">
        <button
          *ngIf="showSaveButton"
          mat-button
          (click)="saveScenarioDynamicItemsModel()"
          class="toolbar-action-btn m-l-auto"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
